import { AuthenticationService } from '../services/AuthenticationService'

export function useAuthenticationService(): AuthenticationService {
  return new AuthenticationService(useApiClient(), useUserStore())
}